import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AgreementsService } from 'src/app/pages/agreements/services/agreements.service';
import { Organisation } from '../../models/gql/organisation.model';
import { UtilityService } from '../../services/utility.service';

@Component({
  selector: 'app-terms-and-conditions-modal',
  templateUrl: './terms-and-conditions-modal.component.html',
  styleUrls: ['./terms-and-conditions-modal.component.scss'],
})
export class TermsAndConditionsComponent {
  @Input()
  terms: Organisation;

  @Input()
  action: string;

  // Indicates if agreement is requested by the client
  @Input()
  isAgreementRequested = false;

  constructor(
    protected modalCtrl: ModalController,
    private agreementService: AgreementsService,
    private utilityService: UtilityService,
  ) {}

  /**
   * Close the modal popup.
   *
   * @param action - Contains action detail to 'Accept' or 'Cancel' terms.
   */
  dismiss(action: string): void {
    this.modalCtrl.dismiss(action);
  }

  /**
   * Accept terms and condtions.
   *
   */
  acceptTermsAndConditions(): void {
    // If user has new agreement then don't need to call acceptCancelUserOrganisationTerm query
    if (this.action === 'add') {
      this.dismiss('accepted');
    } else {
      this.acceptOrCancelUserOrganisationTerm('accepted');
    }
  }

  /**
   * Skip to accept the term and conditions.
   *
   */
  cancel(): void {
    // If user has new agreement or user is amending the requested agreement then don't need to call acceptCancelUserOrganisationTerm query
    // because in that case we are not allowing to update the T&C status and proceed further.
    if (this.action === 'add' || ('edit' && this.isAgreementRequested)) {
      this.dismiss('cancelled');
    } else {
      this.acceptOrCancelUserOrganisationTerm('cancelled');
    }
  }

  /**
   * Update the status of organisation terms.
   *
   * @param action - Contains action detail to 'Accept' or 'Cancel' terms.
   */
  async acceptOrCancelUserOrganisationTerm(action: 'accepted' | 'cancelled'): Promise<void> {
    const loader = await this.utilityService.showLoading();
    try {
      await this.agreementService.acceptOrCancelUserOrganisationTerm(this.terms?.id, action);
    } catch (err) {
      this.utilityService.showErrorAlert('Error updating the terms status. Please try again later.');
    } finally {
      await this.utilityService.hideLoading(loader);
      this.dismiss(action);
    }
  }
}
